import React from 'react';

interface Step3AgenciesCountProps {
  hasCarteT: boolean | null;
  partnerAgenciesCount: number | null;
  onChange: (count: number) => void;
}

const AGENCY_OPTIONS = [
  { value: 0, label: 'Aucune' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4+' },
];

const Step3AgenciesCount: React.FC<Step3AgenciesCountProps> = ({ hasCarteT, partnerAgenciesCount, onChange }) => (
  <div className="space-y-3">
    <p className="text-sm text-gray-600">
      {hasCarteT 
        ? "Indiquez le nombre d'agences partenaires avec lesquelles vous travaillez actuellement."
        : "Indiquez le nombre d'agences partenaires avec lesquelles vous souhaitez travailler."}
    </p>
    <div className="flex flex-wrap gap-2">
      {AGENCY_OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={`
            rounded-lg border-2 px-4 py-2 text-sm font-medium transition-all
            ${partnerAgenciesCount === option.value
              ? 'border-rgpd-blue-light bg-rgpd-blue-light/10 text-rgpd-blue-light'
              : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50'
            }
          `}
        >
          {option.label}
        </button>
      ))}
    </div>
  </div>
);

export default Step3AgenciesCount;


